module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_TH.9a2fae10.webp";